import OrganizationInviteScreen from './OrganizationInviteScreen';

export default OrganizationInviteScreen;
